import { createFileRoute } from "@tanstack/react-router";
import { IntegrationsApp } from "./IntegrationsApp";

export const Route = createFileRoute("/integrations/new")({
  validateSearch: (search: Record<string, unknown>): { type?: string } => {
    const type =
      typeof search.type === "string" ? search.type.trim() : undefined;
    return { type: type || undefined };
  },
  component: NewIntegrationPage,
});

function NewIntegrationPage() {
  return <IntegrationsApp />;
}
